import { data } from "jquery";
import {
    FIND_ALL_ACCESSORIES_REQUEST,
    FIND_ALL_ACCESSORIES_SUCCESS,
    FIND_ALL_ACCESSORIES_FAIL,
    FIND_SINGLE_ACCESSORIES_REQUEST,
    FIND_SINGLE_ACCESSORIES_SUCCESS,
    FIND_SINGLE_ACCESSORIES_FAIL,
  } from "../constants/AccessoriesConstant";

const initialState = {
    loading:false,
    action:"Main Accessories",
    result:[],
    response: {},
    singledata:[],
    msg:"",
    error:"",
};
const AccessoriesReducer = (state = initialState, action)=>{
    switch(action.type){
        case FIND_ALL_ACCESSORIES_REQUEST:
            return{
                ...state,
                loading:action.payload,
            };
        case FIND_ALL_ACCESSORIES_SUCCESS:
            return{
                ...state,
                result: action.result,
                loading:action.payload,
                msg:action.msg,
            };
        case FIND_ALL_ACCESSORIES_FAIL:
            return{
                ...state,
                error:action.error,
                loading:action.payload,
                msg:action.msg,
            };
            case FIND_SINGLE_ACCESSORIES_REQUEST:
                return{
                    ...state,
                    loading:action.payload,
                };
            case FIND_SINGLE_ACCESSORIES_SUCCESS:
                return{
                    ...state,
                    result: action.result.result.data,
                    loading:action.payload,
                    msg:action.msg,
                };
            case FIND_SINGLE_ACCESSORIES_FAIL:
                return{
                    ...state,
                    error:action.error,
                    loading:action.payload,
                    msg:action.msg,
                };
            default:
                return state;
    }
};
export default AccessoriesReducer;